import React from 'react'
import styles from './style.module.scss'
import venues from '../common/constants/olympicsVenueEnums'
import { Row, Col, Card } from 'react-bootstrap'
import { PointerRight, Venue } from '@shared/components/ctIcons'
import CustomLink from '@shared/components/customLink'

const Venues = () => {
  return (
    <Row className={`${styles.venue_row}`}>
      <div className="widget-title  d-flex justify-content-between align-items-center">
        <h3 className="small-head d-flex align-items-center  mb-0">
          <span>Venues</span>
        </h3>
      </div>
      {venues.map((venue, index) => (
        <Col key={index} xs={6} md={3} className={`mb-2 gap-1 ${styles.venue_cards} cursor-pointer`}>
          <CustomLink href={venue?.link}>
            <Card>
              <Card.Img variant="top" src={venue.image} alt={venue?.stadiumName} className="rounded" />
              <div className="gap-6">
                <div className={`${styles.heading} mt-2`}>{venue.stadiumName}</div>
                <div style={{ letterSpacing: '1px' }}>
                  {venue.tags.map((tag, index) => (
                    <span
                      key={index}
                      className={`badge bg-white gap-2 me-1 mt-1 ${styles.badge}`}
                      style={{ letterSpacing: '0.8px', fontSize: '10px' }}>
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Card>
          </CustomLink>
        </Col>
      ))}
      <CustomLink href="https://www.oneturf.news/olympics/summer-olympic-games-start-date-venue-details-1938">
        <div className={`${styles.view_more} cursor-pointer rounded`}>
          <Venue />
        </div>
      </CustomLink>
      <div>
        <CustomLink href={'https://www.oneturf.news/olympics/summer-olympic-games-start-date-venue-details-1938'}>
          <div className={`${styles.viewMoreButton} ${styles.titleMascotLink}`}>
            <a>View More</a>
            <span className="ms-2">
              <PointerRight />
            </span>
          </div>
        </CustomLink>
        {/* <CustomLink href='https://www.oneturf.news/olympics/summer-olympic-games-start-date-venue-details-1938'>
        <Button className={`${styles.viewMoreButton} theme-btn btn btn-primary`}>View More</Button>
      </CustomLink> */}
      </div>
    </Row>
  )
}

export default Venues
